export const redirectToReportsAndExports = (params = '') => {
  const redirectURL = new URL(`/my_reports${params}#exports`, window.location.origin);
  window.location.assign(redirectURL.href);
};
